import { computed, useAttrs } from 'vue';

export const useListeners = () => {
    const attrs = useAttrs();
    const listeners = computed(() => Object.fromEntries(Object.entries(attrs).filter(([key]) => key.startsWith('on'))));

    return {
        listeners,
    };
};